var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1739345988441,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7118,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.336 1014.59H99.395C44.477 1014.59 0 969.79 0 914.62V99.84C0 44.8 44.483 0 99.395 0h654.848c54.845 0 99.328 44.8 99.328 99.968v375.296a291.84 291.84 0 0 0-193.92 16.445c-139.648 62.464-217.283 202.88-186.307 351.232a324.736 324.736 0 0 0 100.992 171.648z m-452.29-751.867v22.405c0 15.744 12.677 28.544 28.354 28.544h411.008c15.683 0 28.355-12.8 28.355-28.544v-22.405a28.416 28.416 0 0 0-28.355-28.544h-410.88a28.472 28.472 0 0 0-28.483 28.544z m0 159.17v22.4c0 15.806 8.575 28.544 19.2 28.544h277.631c10.691 0 19.2-12.8 19.2-28.544v-22.405c0-15.744-8.509-28.544-19.2-28.544H141.256c-10.63 0-19.2 12.8-19.2 28.544z",
    "p-id": 7119,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M778.24 532.48c-135.731 0-245.76 110.029-245.76 245.76S642.509 1024 778.24 1024 1024 913.971 1024 778.24 913.971 532.48 778.24 532.48z m112.686 315.003c3.748 3.748 3.748 9.825 0 13.573l-29.87 29.87a9.6 9.6 0 0 1-13.578 0l-69.238-69.243-69.238 69.243a9.6 9.6 0 0 1-13.578 0l-29.87-29.87a9.6 9.6 0 0 1 0-13.573l69.243-69.243-69.243-69.238a9.6 9.6 0 0 1 0-13.578l29.87-29.87a9.6 9.6 0 0 1 13.578 0l69.238 69.243 69.243-69.243a9.6 9.6 0 0 1 13.573 0l29.87 29.87c3.748 3.748 3.748 9.83 0 13.573l-69.243 69.243 69.243 69.243z",
    "p-id": 7120,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLog);
export default __webpack_public_path__ + "static/media/error-log.3ce8bdf6f7c27297efba73c000799bbd.svg";
export { ForwardRef as ReactComponent };